import * as THREE from 'three';

interface LineProps {
  startPoint: THREE.Vector3;
  endPoint: THREE.Vector3;
}
export class LineScale extends THREE.Line {
  material = new THREE.LineBasicMaterial({ color: 0x000000, linewidth: 1 });
  constructor({ startPoint, endPoint }: LineProps) {
    super();
    this.name = 'line_scale';

    this.buildGeometry(startPoint, endPoint);
  }

  buildGeometry(p1: THREE.Vector3, p2: THREE.Vector3) {
    this.geometry = new THREE.Geometry().setFromPoints([p1, p2]);
  }
  updateLine(index: number, newPos: THREE.Vector3) {
    const geomLine = this.geometry as THREE.Geometry;
    geomLine.vertices[index].copy(newPos);
    geomLine.verticesNeedUpdate = true;
  }
  removeMesh() {
    this.material.dispose();
    this.geometry.dispose();
    this.parent?.remove(this);
  }
}
